import { KioskTypeEnum } from "../../shared/constants/kiosk-type.enum";
import { AbstractItem } from "./abstract-hoarding";

export class Kiosk extends AbstractItem {
    quantity: any;
    kioskType: KioskTypeEnum;
    tradedAsset: boolean;
    vendorName: string;
    rating: number
}